import { generateLegends } from '~/utils/chart/customLegends/general'

export const generateSimpleLegends = {
  id: 'htmlLegend',
  afterUpdate(chart, _, options) {
    generateLegends(chart, options, 'simple')
  },
}
